import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";
import {Brand} from "./Brand";

@Injectable({
   providedIn: 'root'
})
export class TessutoFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService) {
   }

   async getTessuti(vendorSlug):Promise<Tessuto[]> {
      let url = vendorSlug ? `/api/esercizi/${vendorSlug}/tessuti` : `/api/tessuti`
      return new Promise((resolve, reject) => {
         ServerService.instance.getAll(Tessuto, url).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async postTessuto(data, vendorSlug=null):Promise<Tessuto[]> {
      return new Promise((resolve, reject) => {
         let url = vendorSlug ?`/api/esercizi/${vendorSlug}/tessuti` : `/api/tessuti`
         ServerService.instance.post( url, data, Tessuto).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async putTessuto(tessutoId, data):Promise<Tessuto[]> {
      return new Promise((resolve, reject) => {
         ServerService.instance.put( `/api/tessuti/${tessutoId}`, data, Tessuto).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async deleteTessuto(tessutoId):Promise<Tessuto[]> {
      return new Promise((resolve, reject) => {
         ServerService.instance.delete( `/api/tessuti/${tessutoId}`, {}, Tessuto).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async approvaTessuto(tessutoId) {
      return new Promise((resolve, reject) => {
         ServerService.instance.put( `/api/tessuti/${tessutoId}/approva`, {}, Tessuto).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

}

export class TessutoData {
  id?: number;
  nome?: string;
}

export class Tessuto {

  data:TessutoData = {}

  constructor(data:TessutoData) {
    // assegno al mio oggetto data (è un json)
    if(!data) data = {}
    Object.assign(this.data, data)
  }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/tessuti`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }



}
